import { useCallback } from 'react';

import { useNavigate } from './useNavigate';

export const useRemoveQueryParams = () => {
    const navigateWithReplace = useNavigate({ replace: true });

    return useCallback(removeParams => {
        const { location, history } = window;

        navigateWithReplace(location, history.state?.state, { removeParams, preserveHash: true });
    }, [navigateWithReplace]);
};
